import { render, staticRenderFns } from "./IntelligenceSupplyDemandTable.vue?vue&type=template&id=48d631c6&scoped=true"
import script from "./IntelligenceSupplyDemandTable.vue?vue&type=script&lang=js"
export * from "./IntelligenceSupplyDemandTable.vue?vue&type=script&lang=js"
import style0 from "./IntelligenceSupplyDemandTable.vue?vue&type=style&index=0&id=48d631c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d631c6",
  null
  
)

export default component.exports